/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/scenario-mapper/scenario-conversation',['require','jquery','underscore','core/templates','screens/scenario-mapper/scenario-asset','screens/scenario-mapper/scenario-dialog','screens/scenario-mapper/scenario-mapper-view'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');

  var templates = require('core/templates');

  var Scenario;
  require(['screens/scenario-mapper/scenario'], function(a) {
    Scenario = a;
  });
  //var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioAsset = require('screens/scenario-mapper/scenario-asset');
  var ScenarioDialog = require('screens/scenario-mapper/scenario-dialog');
  var ScenarioMapperView = require('screens/scenario-mapper/scenario-mapper-view');
  //var ScenarioItem = require('screens/scenario-mapper/scenario-item');
  //var ScenarioUtils = require('screens/scenario-mapper/scenario-utils');

  /*****************************************************************************************************************///}

  var ScenarioConversation = ScenarioAsset.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    //template: templates['screens/observe-assess/scene'],
    // events: {
    //   'click .btn': 'btnPressed'
    // },
    name: null,
    title: null,
    bgImageName: null,
    imagePath: null,
    description: null,

    bg: null,
    bgImg: null,
    bgContainerMC: null,
    staticContainerMC: null,
    chatContainerMC: null,

    rootDialog: null,
    dialogArr: [],

    dialogsReady: false,
    bgReady: false,

    dialogCount: 0,
    dialogReadyCount: 0,

    hotspotsArr: [],

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      ScenarioConversation.instancesArr.push(this);
      this.hotspotsArr = [];
      this.dialogArr = [];
      ScenarioAsset.prototype.initialize.apply(this, arguments);
    },

    onBeforeDestroy: function()
    {
      this.clearHotspots();
      this.dialogArr = [];
      this.rootDialog = null;

      this.bg = null;
      this.bgContainerMC = null;
      this.staticContainerMC = null;
      this.chatContainerMC = null;
    },

    begin: function($dialog, $force)
    {
      $dialog = ($dialog === undefined) ? null : $dialog;
      $force = ($force === undefined) ? false : $force;

      ////console.log('BEGINNING CONVO: ' + _id);
      $dialog = ($dialog !== null) ? $dialog : this.rootDialog;
      this.checkDialog($dialog, $force);
    },

    end: function()
    {
      //clearHotspots();
    },

    hideHotspots: function($ignoreArr)
    {
      $ignoreArr = ($ignoreArr === undefined) ? [] : $ignoreArr;

      _.each(this.hotspotsArr, function($hsBtn) {
        //console.log('hide ', $hsBtn);
        if ($.inArray($hsBtn.attr('data-mc'), $ignoreArr) === -1)
        {
          $hsBtn.hide();
        }
      });
    },

    clearHotspots: function()
    {
      _.each(this.hotspotsArr, function($button) {
        $button.off('click');// = null;
        //$button.destroy();
      });
      this.hotspotsArr = [];
    },

    addHotspot: function($btn)
    {
      this.hotspotsArr.push($btn);
    },

    updateActiveHotspots: function()
    {
      var $dialog;
      _.each(this.hotspotsArr, function($button) {
        $dialog = $button.data().dialog;
        ////console.log('check dialog: ' + $dialog.name, $dialog.mcName, $dialog.getAvailable());
        if ($dialog)
        {
          if ($dialog.getAvailable() === true)
            $button.show();
          else
            $button.hide();
        }
      });
    },

    checkDialog: function($dialog, $force)
    {
      $force = ($force === undefined) ? false : $force;
      ////console.log('checkDialog: ' + $dialog.id);

      switch ($dialog.nodeType)
      {
        case Scenario.NODE_TYPE_ROOT:
          ////console.log('root');
          this.trigger(Scenario.SHOW_CONVERSATION, this);
          $dialog.activate();
          break;
        case Scenario.NODE_TYPE_FEEDBACK:
          ////console.log('feedback');
          $dialog.activate();
          break;
        case Scenario.NODE_TYPE_HOTSPOT:
          ////console.log('HOTSPOT');
          $dialog.activate();
          this.trigger(Scenario.SHOW_DIALOG, $dialog);
          break;
        case Scenario.NODE_TYPE_RADIAL:
          this.trigger(Scenario.SHOW_DIALOG, $dialog);
          break;
        case Scenario.NODE_TYPE_FOLLOW:
          $dialog.activate();
          break;
        case Scenario.NODE_TYPE_CHAT:
          ////console.log('CHAT');
          $dialog.activate();
          this.trigger(Scenario.SHOW_DIALOG, $dialog);
          break;
        case Scenario.NODE_TYPE_ACTIVITY:
          ////console.log('CHAT');
          if ($dialog.getAvailable() || $force)
          {
            if ($force)
            {
              this.trigger(Scenario.SHOW_CONVERSATION, this);
            }
            $dialog.activate();
            this.trigger(Scenario.SHOW_DIALOG, $dialog);
          }
          else
          {
            $dialog.checkBranches();
          }
          break;
        case Scenario.NODE_TYPE_ENDPOINT:
          $dialog.activate();
          break;
        case Scenario.NODE_TYPE_TREE:
          $dialog.activate();
          break;
        default:
          console.warn('UNKNOWN NODE TYPE: ' + $dialog.nodeType);
          break;
      }
    },

    /*****************************************************************************************************************///}

    ///////////////////////
    // INTERNAL METHODS //{
    ///////////////////////

    parseData: function(data)
    {
      ScenarioAsset.prototype.parseData.apply(this, arguments);

      this.saType = ScenarioAsset.SA_TYPE_CONVERSATION;

      this.name = data.Fields.Title;
      this.title = data.Fields.Title;
      this.bgImageName = data.Fields.bgImage;
      this.imagePath = ('content/graphics/' + this.bgImageName).replace('.swf', '_bg.jpg');
      this.description = data.Fields.Description;

      var $dialogArr = data.DialogNodes;
      var $sd;

      this.dialogCount++;
      var $dObj;
      for (var $key in $dialogArr)
      {
        $dObj = $dialogArr[$key];
        this.dialogCount++;
        $sd = new ScenarioDialog($dObj, this);
        if (!$sd.isReady)
        {
          $sd.on('CONTENT_READY', this.onDialogReadyHandler.bind(this));
        }
        else
        {
          this.dialogReadyCount++;
        }
        if ($sd.isRoot)
        {
          this.rootDialog = $sd;
        }
        this.dialogArr.push($sd);
      }

      this.dialogReadyCount++;
      this.onDialogReadyHandler(null);

      var View = ScenarioMapperView;
      var $nameStr = this.bgImageName.replace('.swf', '').replace(/_/g, '-');
      ////console.log('bgimagename', this.bgImageName, $nameStr);
      if (!templates['scenario-views/' + $nameStr])
      {
        //console.error('Missing View Template HTML: ', 'scenario-views/' + $nameStr);
        ScenarioConversation.viewErrorArr.push({'View Name': 'scenario-views/' + $nameStr});
        return false;
      }
      else
      {
        this.bgView = new View({ template: templates['scenario-views/' + $nameStr], className: $nameStr });

        this.bg = this.bgView.$el;
      }

      if (this.bgImageName.indexOf('.swf') !== -1)
      {
        var $bgimg = $('<img>');
        $bgimg.on('load', $.proxy(this.onBGLoadedHandler, this, $bgimg));
        $bgimg.on('error', $.proxy(this.onBGLoadedHandler, this, $bgimg, false));
        $bgimg.attr('src', this.imagePath).addClass('main-img');
        //require([this.imagePath], this.onBGLoadedHandler.bind(this));
      }
      else
      {
        var $masterConvo = Scenario.getConversationByID(this.bgImageName.replace('convo_', ''));
        if ($masterConvo)
        {
          //console.log('FOUND MASTER CONVO');
          if ($masterConvo.bg)
          {
            //console.log('BG ALREADY LOADED, mapping');
            this.mapBG($masterConvo.bg);
          }
          else
          {
            //console.log('BG NOT READY YET, waiting');
            $masterConvo.on(Scenario.CONVO_READY, this.masterConvoReady.bind(this));
          }
        }
        else
        {
          console.error('Parent ConvoID not found: ' + this.bgImageName);
        }
      }
    },

    masterConvoReady: function(evt)
    {
      var $convo = evt.target;
      $convo.off(Scenario.CONVO_READY, this.masterConvoReady);
      if ($convo)
      {
        //console.log('MASTER CONVO FOUND, mapping: ' + $convo.bg);
        this.mapBG($convo.bg);
      }
    },

    onMCClickHandler: function(evt)
    {
      this.selectDialog(evt.currentTarget.dialog);
    },

    selectDialog: function($dialog)
    {
      this.trigger(Scenario.LOAD_CONVERSATION_BY_ID, $dialog.id);
    },

    onBGLoadedHandler: function($img, $success)
    {
      $success = ($success === undefined) ? true : $success;

      if ($success)
      {
        this.bgImg = $img;
        //add image to convo view $bgMC
      }
      else
      {
        console.error('Conversation BG Img not found: ', $img.attr('src'));
      }

      /*var View = ScenarioMapperView;
      var $nameStr = this.bgImageName.replace('.swf', '').replace(/_/g, '-');
      ////console.log('bgimagename', this.bgImageName, $nameStr);
      if (!templates['scenario-views/' + $nameStr])
      {
        //console.error('Missing View Template HTML: ', 'scenario-views/' + $nameStr);
        ScenarioConversation.viewErrorArr.push({'View Name': 'scenario-views/' + $nameStr});

        this.bgReady = true;
        this.checkReady();
        return false;
      }

      this.bgView = new View({ template: templates['scenario-views/' + $nameStr], className: $nameStr });*/

      this.mapBG(this.bgView.$el);
    },

    mapBG: function($bgMC)
    {
      ////console.log('mapping bg');
      if (this.bg)
      {
        this.chatContainerMC = this.bg.find('[data-mc=chat_mc]');
        this.staticContainerMC = this.bg.find('[data-mc=static_mc]');
        this.bgContainerMC = this.bg.find('[data-mc=background_mc]');
        this.bgContainerMC.find('.background-img-container').append(this.bgImg);
        this.stopAllBgMC();
      }
      else
      {
        console.error('Missing View');
      }

      this.bgReady = true;
      this.checkReady();
    },

    stopAllBgMC: function()
    {
      _.each(this.bgContainerMC, function($child) {
        if ($($child).attr('data-mc'))
        {
          $($child).attr('data-frame', 'default');
        }
      });
    },

    onDialogReadyHandler: function(evt)
    {
      this.dialogReadyCount++;
      ////console.log('dialog ready : ' + this.dialogReadyCount, this.dialogCount);
      if (this.dialogReadyCount === this.dialogCount)
      {
        this.dialogsReady = true;
        this.checkReady();
      }
    },

    checkReady: function()
    {
      if (this.bgReady && this.dialogsReady)
      {
        //console.log('convo ready', this.id);
        this.trigger(Scenario.CONVO_READY, this);
      }
    }

  /*****************************************************************************************************************///}

  });

  ScenarioConversation.instancesArr = [];
  ScenarioConversation.viewErrorArr = [];

  ScenarioConversation.destroy = function()
  {
    _.each(ScenarioConversation.instancesArr, function(instance) {
      instance.destroy();
    });

    ScenarioConversation.instancesArr = [];
    ScenarioConversation.viewErrorArr = [];
  };

  return ScenarioConversation;

});

